class DesignersHub {
  constructor(root) {
    this.root = root;
    this.alphaNav = root.querySelector('[data-designers-alpha]');
    this.alphaLinks = root.querySelectorAll('.designers-hub__alpha-link');
    this.letterGroups = root.querySelectorAll('.designers-hub__letter-group');

    this.rebalanceIndexColumns();
    this.filterLegacyList();
    this.pruneEmptyLetterGroups();

    this.letterGroups = this.root.querySelectorAll('.designers-hub__letter-group');

    if (!this.alphaNav || this.alphaLinks.length === 0) return;

    this.bind();
    this.observeLetters();
  }

  normalizeDesignerKey(value) {
    return value
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  getExcludedKeys() {
    const raw = this.root.dataset.excludedDesigners;
    if (!raw) return new Set();

    return new Set(
      raw
        .split('\n')
        .map((line) => this.normalizeDesignerKey(line))
        .filter(Boolean)
    );
  }

  isExcluded(label, excludedKeys) {
    const key = this.normalizeDesignerKey(label);
    return excludedKeys.has(key);
  }

  rebalanceIndexColumns() {
    const index = this.root.querySelector('.designers-hub__index');
    if (!index) return;

    const groups = [...index.querySelectorAll('.designers-hub__letter-group')];
    if (groups.length === 0) return;

    const firstColumnLetters = 'ABCDEFGHIJK';
    const colFirst = document.createElement('div');
    const colSecond = document.createElement('div');

    colFirst.className = 'designers-hub__index-col designers-hub__index-col--first';
    colSecond.className = 'designers-hub__index-col designers-hub__index-col--second';

    groups.forEach((group) => {
      const letter = group.id.replace('designer-letter-', '');
      if (firstColumnLetters.includes(letter)) {
        colFirst.appendChild(group);
      } else {
        colSecond.appendChild(group);
      }
    });

    index.replaceChildren(colFirst, colSecond);
  }

  filterLegacyList() {
    const legacy = this.root.querySelector('.designers-hub__legacy');
    const excludedKeys = this.getExcludedKeys();

    if (!legacy || excludedKeys.size === 0) return;

    legacy.querySelectorAll('a').forEach((link) => {
      if (!this.isExcluded(link.textContent, excludedKeys)) return;

      const row = link.closest('li') || link.parentElement;
      if (row) row.remove();
      else link.remove();
    });
  }

  pruneEmptyLetterGroups() {
    this.root.querySelectorAll('.designers-hub__letter-group').forEach((group) => {
      const items = group.querySelectorAll('.designers-hub__name-item');
      if (items.length > 0) return;

      const letter = group.id.replace('designer-letter-', '');
      group.remove();

      this.alphaLinks.forEach((link) => {
        if (link.getAttribute('href') === `#designer-letter-${letter}`) {
          link.closest('li')?.remove();
        }
      });
    });
  }

  bind() {
    this.alphaLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const id = link.getAttribute('href')?.slice(1);
        const target = id ? document.getElementById(id) : null;

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', `#${id}`);
        }
      });
    });
  }

  observeLetters() {
    if (!window.IntersectionObserver) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const id = entry.target.id;
          this.alphaLinks.forEach((link) => {
            const isActive = link.getAttribute('href') === `#${id}`;
            link.classList.toggle('is-active', isActive);
          });
        });
      },
      {
        rootMargin: `-${getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '4.5rem'} 0px -60% 0px`,
        threshold: 0
      }
    );

    this.letterGroups.forEach((group) => observer.observe(group));
  }
}

function initDesignersHub() {
  document.querySelectorAll('[data-designers-hub]').forEach((root) => {
    new DesignersHub(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDesignersHub);
} else {
  initDesignersHub();
}
